module.exports = __webpack_public_path__ + "static/media/1.ac1a33c3.png";